import { Navigate, useParams } from "react-router-dom";

/**
 * Funciones de la tienda pública de boletos que todavía NO tienen datos reales
 * (revisión #1568, A9): «Mis reservas», «Mi perfil / Mi cuenta /
 * Configuraciones», la campana de notificaciones y el chat de ayuda muestran
 * contenido de maqueta. Hasta que lean datos reales del comprador quedan
 * ocultas y sus rutas regresan a la portada de la tienda.
 */
export const STOREFRONT_ACCOUNT_FEATURES = false;

/** Rutas que sólo tienen sentido con cuenta real: con la bandera apagada, a la portada. */
export function StorefrontAccountGate({ children }: { children: React.ReactNode }) {
  const { slug = "" } = useParams();
  if (!STOREFRONT_ACCOUNT_FEATURES) return <Navigate to={`/rides/${slug}`} replace />;
  return <>{children}</>;
}
